module.exports = __webpack_public_path__ + "img/black.a16b0894.png";